import React from "react";
import "./IES.scss";
import ServerImage from "../../Assits/IES1.jpg";
import CompImage from "../../Assits/IES2.jpg";
const IES = () => {
  return (
    <div className="IES">
      <h2>Industrial Engineering Solutions</h2>

      <h3>1. Industrial Control &amp; Automation</h3>
      <img src={ServerImage} alt="Server" />
      <p>
        With about 10 plus years of working experience in the field in Pakistan,
        Qatar, KSA and UAE, our team of engineers possesses in-depth knowledge
        of Electrical, Instrumentation &amp; PLC/DCS based control &amp; SCADA
        systems. We can provide complete services for E&amp;I. We are fully
        conversant with engineering and industrial standards. Our team of
        engineers has successfully implemented several challenging projects.
      </p>
      <p>
        Moreover, we have a pool of highly qualified technical experts working
        as our associates and having vast experience in Electrical,
        Instrumentation and Power Projects. With this association with a group
        of companies, we have attained resources and capability for executing
        projects from inception until completion.
      </p>
      <h3>2. Turnkey Projects:</h3>
      <p>
        We offer turnkey solutions for process &amp; machine controls including
        complete installation, engineering &amp; commissioning services of
        instrumentation &amp; control.
      </p>
      <p>
        Petroen  Trading & Engineering ’s highly trained engineers and friendly
        customer service professionals can find the optimal solution for the
        most demanding applications. This unique combination enables Petroen 
        Engineering to offer our customers the best instrument value in the
        industry.
      </p>
      <h3>3. Instrumentation </h3>
      <p>
        Petroen  Trading & Engineering offers process measurement and control
        solutions. Our offered products and solutions are being used to measure
        and control flow, pressure, level, temperature and analytical. We
        provide broad lines of sensors, switches and transmitters in the
        industry.
      </p>
      <p>
        We offer a wide range of flow meters for both liquid and gas
        applications including variable area flow meters, paddle wheel flow
        meters, turbine flow meters, vortex flow meters, oval gear meters,
        target flow meters, magnetic flow meters, Coriolis flow meters and many
        more. We also offer a wide range of flow switches and flow transmitters.
      </p>
      <p>
        Our&nbsp;pressure offering includes mechanical pressure switches,
        electronic pressure switches, mechanical pressure gauges, electronic
        pressure gauges and pressure transmitters.
      </p>
      <p>
        Petroen  Trading & Engineering level products include float level
        switches, optical level switches, ultrasonic level switches, conductive
        level switches, and many more. Petroen  Trading & Engineering also offers
        a broad range of level transmitters including float-type level
        transmitters, magnetostrictive level transmitters, ultrasonic level
        transmitters and capacitance level transmitters. We also provide bypass
        level gauges and mini-bypass level gauges which are mounted on tanks to
        provide a visual indication of the level together with optional level
        switches and level transmitters.
      </p>
      <p>
        We have many types of temperature measurement and control products
        including temperature switches, temperature gauges and temperature
        transmitters.
      </p>
      <img src={CompImage} alt={"Computers"} />
      <h3>4. Control, Automation &amp; SCADA systems</h3>
      <p>
        We offer products and services for all kind of leading PLC Control
        System including Rockwell Automation, Schneider Electric (Telemecanique)
        automation, Siemens- &amp;, Mitsubishi Electric.
      </p>
      <h3>5. Valves</h3>
      <p>
        Petroen Engineering offers all kinds and sizes of industrial valves like
        gate, butterfly, globe, check, ball valve, non-return valves, pressure
        relief valve etc. Our offered valves are hand lever operated, gearbox
        operated, electric actuator/pneumatic operated, on-off as well as
        proportional control)to all kinds of industries including oil and gas,
        chemical, petrochemicals, water &amp; wastewater, food &amp; beverages
        etc.
      </p>
      <h3>6. Fire &amp; Safety System</h3>
      <h4>
        6.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Safety &amp; Security Systems:
      </h4>
      <p>
        We offer a full range of reliable and state of the art Security Systems.
        Applications of our products and equipment include Restricted Areas,
        Residential and Commercial Buildings, Commercial Banks, Show Rooms,
        Departmental Stores, Industrial Buildings, Warehouses etc. Main products
        for security systems offered by us include fire alarm and detection
        system, automatic fire suppression system FM200, CCTV system, public
        address system, access control system etc.
      </p>
      <h4>6.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fire &amp; Gas Systems:</h4>
      <p>
        We offer complete turnkey Fire &amp; Gas Systems that include field
        devices i.e. flame detectors, combustible and toxic gas detectors,
        surveillance and Hazard Detection, manual call point, beacon sounders
        etc. and their control systems based on DMR, TMR or QMR and their
        installation, testing and commissioning.
      </p>
      <h3>7. Building Management Systems</h3>
      <p>
        Petroen  Trading & Engineering has a team of professionals who carried
        out many successful turnkey projects in building management system on
        the following products/systems:
      </p>
      <ul>
        <li>Johnson Controls</li>
        <li>TAC</li>
        <li>Siemens</li>
        <li>Distech Controls</li>
        <li>Tridium</li>
      </ul>
      <h3>8. Electrical &amp; Power</h3>
      <h4>
        8.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Switchgear Supply and Allied
        Engineering Services:
      </h4>
      <ul>
        <li>
          LV Switch Gear i.e. Main Incoming Panels, Motor Control Centre (MCC),
          Power Factor Improvement (PFI) &amp; Power Distribution Panels.
        </li>
        <li>
          All type of Control panels i.e. PLC, DCS and AC / DC Drive panels.
        </li>
        <li>
          Synchronizing &amp; Load Sharing panels, Manual Changeover (MCO), Auto
          Mains Failure (AMF), Auto Transfer Switch (ATS) &amp; Manual Override
          (MOR) Panels.
        </li>
      </ul>
      <h4>
        8.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Electrical Engineering Services:
      </h4>
      <ul>
        <li>
          All type of Electrical Engineering Services i.e. Erection,
          Commissioning and Shut Down Services on Power Plants, Water Treatment
          Plants, Process and Batch Industries
        </li>
        <li>
          Fabrication and Erection of all kinds of (Hot Dip Galvanized or Powder
          coated) Cable Trays, Cable Ladders and allied accessories
        </li>
        <li>
          Supply, Laying and Termination of all kind of Power and Control
          Cables.
        </li>
        <li>
          Installation, Testing, Commissioning &amp; Maintenance Services for
          all kinds of Low Voltage Electrical Equipment.
        </li>
        <li>
          Engineering Services of Indoor and Out Door Lighting System i.e.
          Security Lights, Street Lights and Flood Lights.
        </li>
        <li>Earthing System.</li>
      </ul>
      <h4>8.3 &nbsp; &nbsp; &nbsp; Generator Sets &amp; Allied services:</h4>
      <ul>
        <li>
          Supply, Installation &amp; Commissioning services of Diesel/Gas
          Generators.
        </li>
        <li>
          Facility of Minor &amp; Major overhauling of Diesel/Gas generators
          along with the supply of all kinds of generator set parts &amp;
          consumables (Oil, Fuel and Air Filters etc.).
        </li>
        <li>
          Supply, installation &amp; commissioning services of Generator Control
          and Synchronization and Load Sharing Modules.
        </li>
        <li>Annual Operation/Maintenance Contracts.</li>
      </ul>
    </div>
  );
};
export default IES;
